import React from "react";

export default function Loading({ text }) {
  return (
    <>
      {text} <i className="fa-solid fa-spinner fa-2xl spinner"></i>
    </>
  );
}
